//Dropdown
$('.ui.dropdown').dropdown();
$('.selection.dropdown').dropdown();
$('select.dropdown.statut, select.dropdown.droit').dropdown();
$('.inline.dropdown').dropdown();
